import { useEffect } from 'react';
import { logger } from './logger';

/**
 * React-Hook, der Strg+Shift+L registriert. Beim Auslösen wird der aktuelle
 * Logger-Buffer als Text in die Zwischenablage kopiert.
 *
 * Verwendung in einer App-weit gemounteten Komponente (z.B. App.tsx):
 *   useCopyLogsHotkey();
 */
export function useCopyLogsHotkey(): void {
  useEffect(() => {
    const handler = async (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'L') {
        e.preventDefault();
        const text = logger.formatBufferAsText();
        try {
          await navigator.clipboard.writeText(text);
          logger.info('ui', `Logs copied to clipboard (${text.split('\n').length} entries)`);
        } catch (err) {
          logger.error('error', 'clipboard write failed', { error: String(err) });
        }
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);
}
